import ipaddr from 'ipaddr.js';

export function isLinkLocalIPv4(ip: string): boolean {
  return !!ip.match(/^169\.254/i);
}

export function isLinkLocalIPv6(ip: string): boolean {
  return /^FE80/i.exec(ip) !== null;
}

export function getSubnetFromCidr(cidr: string): string | null {
  try {
    const [address, prefixLength] = ipaddr.parseCIDR(cidr);
    const networkAddress = address.kind() === 'ipv6'
      ? ipaddr.IPv6.networkAddressFromCIDR(cidr)
      : ipaddr.IPv4.networkAddressFromCIDR(cidr);
    return `${networkAddress.toString()}/${prefixLength}`;
  } catch (e) {
    return null;
  }
}

export function reverseIp(ip: string): string {
  return ip.split('.').reverse().join('.');
}

export function getIpVersion(ip: string): 6 | 4 | null {
  let ipParsed: ipaddr.IPv4 | ipaddr.IPv6;
  try {
    ipParsed = ipaddr.parse(ip);
  } catch (e) {
    return null;
  }
  return ipParsed.kind() === 'ipv6' ? 6 : 4;
}
